export default class BackedEnum {
  static values() {
    return Object.keys(this)
      .filter((key) => /^[A-Z]/.test(key) && /^[A-Z_]+$/.test(this[key]))
      .map((key) => this[key]);
  }
}
